import React, { useState, ChangeEvent } from 'react'
import SelectInput, { IOption } from '../SelectInput';

type TValueTypes = number | string;

interface IEditSelectInputPropTypes {
  value: TValueTypes;
  options: TValueTypes[];
  type?: "number" | "text";
  readonly?: boolean;
  onChange: (value: string) => void
}

export default function EditSelectInput(props: IEditSelectInputPropTypes) {
  const { value, options, type = "text", readonly = false, onChange } = props;
  const [_value, setValue] = useState<TValueTypes>(value);

  const handleChange = (o: IOption) => {
    const nextValue = o.value;
    setValue(nextValue);
    onChange(nextValue);
  }

  const _options: IOption[] = options.map(o => { return {value: o.toString(), label: o.toString()} })
  if(readonly) {
    return <span>{_value}</span>;
  }
  return (
    <SelectInput
    type={type}
    options={_options}
    initialOption={{ value: _value.toString(), label: _value.toString()}}
    onChange={o => handleChange(o)}
  />
  )
}
